import "./ComponentStyles/Events.css";

function Events(props) {
  return (
    <div id="calendar-container">
        <iframe
            id="calendar"
            title="calendar"
            src="https://calendar.google.com/calendar/embed?src=umbc.edu_4g9lrsl8mmfm2u0b9i61cqbgqo%40group.calendar.google.com&amp;ctz=America/New_York"
            width={"85%"}
            height={900}>
        </iframe>
    </div>
  );
}

export default Events;